// extracted by mini-css-extract-plugin
export default {"button":"Button_button__ZWb41","primary":"Button_primary__-ZpkL","secondary":"Button_secondary__x35ZB"};